module.exports = __webpack_public_path__ + "files/af680a66e6c0c063dca2d788c6a60d60.png";